import { useTranslations } from "@jugl-web/utils";
import { useMemo } from "react";

export const useBoardSettingsHints = () => {
  const { t } = useTranslations();

  const boardIdPrefixHint = useMemo<string>(
    () =>
      t({
        id: "form-controls.board-id-prefix-hint",
        defaultMessage:
          "Board ID Prefix is as 6 digit unique code that will identify all the Tasks created inside this Board 🤓",
      }),
    [t]
  );

  const ownerRoleHints = useMemo<string[]>(
    () => [
      t({
        id: "form-controls.board-admins-tooltip-manage-info",
        defaultMessage: "Admin of the Board can fully manage its info ✅",
      }),
      t({
        id: "form-controls.board-admins-tooltip-partial-access",
        defaultMessage: "Admin has partial access to all Tasks in the Board 🔐",
      }),
      t({
        id: "form-controls.board-admins-tooltip-edit-order-form",
        defaultMessage:
          "Only Admin can edit the Order Form info inside the Task 📝",
      }),
    ],
    [t]
  );

  const memberRoleHints = useMemo<string[]>(
    () => [
      t({
        id: "form-controls.board-members-tooltip-edit-board-info",
        defaultMessage: "Member of the Board cannot edit the Board info 🚫",
      }),
      t({
        id: "form-controls.board-members-tooltip-partial-access",
        defaultMessage:
          "Member of the Board has partial access to all Tasks in the Board 🔐",
      }),
    ],
    [t]
  );

  const viewerRoleHints = useMemo<string[]>(
    () => [
      t({
        id: "form-controls.board-viewers-tooltip-manage-info",
        defaultMessage: "Viewer of the Board cannot edit the Board info 🚫",
      }),
      t({
        id: "form-controls.board-viewers-tooltip-partial-access",
        defaultMessage:
          "Viewer of the Board can only see and comment on all Tasks in the Board 💬",
      }),
    ],
    [t]
  );

  const includeItemsServicesHint = useMemo<string>(
    () =>
      t({
        id: "form-controls.include-items-services-hint",
        defaultMessage:
          'If this setting is turned on - each task in this Board will have "Order details" tab, which allows to create order anytime by selecting "Items/services" from "Catalog" module 😍',
      }),
    [t]
  );

  const includeBillingFilesHint = useMemo<string>(
    () =>
      t({
        id: "form-controls.include-billing-files-hint",
        defaultMessage:
          'If this setting is turned on - each task in this Board will have "Billing Files" tab, which allows to create Invoice, Proforma or Estimate files, and send it to your Customers 😍',
      }),
    [t]
  );

  const taskObjectNamingHint = useMemo<string>(
    () =>
      t({
        id: "tasks-board-form.section.board-settings-how-to-name-items.tooltip",
        defaultMessage:
          "This selection defines the naming of the board items. It will be represented in buttons, titles and all other places in this Board 🆒 You can select from default options or type you own! 🤓",
      }),
    [t]
  );

  const allowGuestLinkSharingHint = useMemo<string>(
    () =>
      t({
        id: "form-controls.allow-guest-link-sharing-hint",
        defaultMessage:
          "Define if tasks in this board can be shared with Guest link 🔐\nBased on the OTP Settings, Guest link can be opened without any visitor authentication, or only with OTP (One Time Password).",
      }),
    [t]
  );

  return {
    boardIdPrefixHint,
    ownerRoleHints,
    memberRoleHints,
    viewerRoleHints,
    taskObjectNamingHint,
    includeItemsServicesHint,
    includeBillingFilesHint,
    allowGuestLinkSharingHint,
  };
};
